<template>
	<!-- eslint-disable -->
	<svg
		version="1.1"
		id="Capa_1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		x="0px"
		y="0px"
		viewBox="0 0 512 512"
		style="enable-background:new 0 0 512 512;"
		xml:space="preserve"
		fill="#ffffff"
		width="100%"
		height="100%%"
	>
		<g>
			<g>
				<path
					d="M480.488,241C473.07,128.863,383.137,38.93,271,31.512V0h-30v31.512C128.863,38.93,38.93,128.863,31.512,241H0v30h31.512
			C38.93,383.137,128.863,473.07,241,480.488V512h30v-31.512C383.137,473.07,473.07,383.137,480.488,271H512v-30H480.488z
			 M241,61.571v60.267C178.521,128.777,128.777,178.521,121.838,241H61.571C68.877,145.409,145.409,68.877,241,61.571z M241,450.429
			C145.409,443.123,68.877,366.591,61.571,271h60.267c6.939,62.479,56.683,112.223,119.162,119.162V450.429z M241,331v28.924
			c-45.916-6.597-82.327-43.008-88.924-88.924H181v-30h-28.924c6.597-45.916,43.008-82.327,88.924-88.924V181h30v-28.924
			c45.916,6.597,82.327,43.008,88.924,88.924H331v30h28.924c-6.597,45.916-43.008,82.327-88.924,88.924V331H241z M271,450.429
			v-60.267c62.479-6.939,112.223-56.684,119.162-119.162h60.267C443.123,366.591,366.591,443.123,271,450.429z M390.162,241
			C383.223,178.521,333.479,128.777,271,121.838V61.571C366.591,68.877,443.123,145.409,450.429,241H390.162z"
				/>
			</g>
		</g>
		<g>
			<g>
				<path
					d="M256,211c-24.813,0-45,20.187-45,45s20.187,45,45,45s45-20.187,45-45S280.813,211,256,211z"
				/>
			</g>
		</g>
	</svg>
</template>
